import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { demoCenterPath } from '../../data/demoCenter';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  const scrollToWork = () => {
    document.getElementById('what-we-build')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-518" data-mp="2wtvbp9363use">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-519" data-mp="31tpyp1jto086">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-520" data-mp="2n3isbk73a7nu">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-521" data-mp="3frei04y8qzb4">
            Connected knowledge. Stronger judgment. Greater human capability.
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-522" data-mp="osuu4q51ehgm">
            SyNeural connects governed knowledge, structured capability
            development and practical action. Our architecture brings together
            the Semantic Knowledge Platform, Human Capability Framework and
            Noetivra workspace to help institutions understand needs,
            coordinate support and evaluate results.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-523" data-mp="12lu8upwzw7n4">
            <button type="button" onClick={scrollToWork} className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-524" data-mp="1gmwyfcn7802s">
              Explore the Platform
              <ArrowRight size={18} aria-hidden="true" data-id="element-525" data-mp="3edr6ft8f2bps" />
            </button>
            <a href={demoCenterPath} className="inline-flex items-center justify-center gap-2 border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-526" data-mp="1hcloeh7te7uc">
              Explore Noetivra Demos
              <ArrowRight size={18} aria-hidden="true" data-id="element-527" data-mp="1w9kshv3gjik2" />
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-528" data-mp="209v9e2ssftdp">
          <IntelligenceDiagram data-id="element-529" data-mp="259hmmc8m99mi" />
        </div>
      </div>
    </section>;
}